import { toNumber } from 'lodash';

const roundNumber = n => Math.round(toNumber(n || 0));

export default roundNumber;
